import { render, staticRenderFns } from "./default-board.vue?vue&type=template&id=6c1dccb2&"
import script from "./default-board.vue?vue&type=script&lang=js&"
export * from "./default-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports